.wrap {
  width: 100%;
  text-align: center;
}

.spinner {
  display: block;
  margin: 0 auto 0.5rem;
  width: 3rem;
  height: 3rem;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

.text {
  margin: 0;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}
